<template>
  <div>
    <ValidationProvider
        :name="formRow.name"
        :rules="rules"
        v-slot="{ passed, failed }"
    >
      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
        <label>{{ $t(formRow.title) }}</label>
        <md-input
            :name="formRow.name"
            v-model="value"
            :placeholder="$t(formRow.title)"
        />
        <slide-y-down-transition>
          <md-icon class="error" v-show="failed">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="passed">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <p v-if="failed" style="text-align: left;">
        <b
            v-if="formRow.attr.validations.length > 0"
            class="text-danger"
        >
          {{ formRow.attr.validations[0].message }}
        </b>
      </p>
    </ValidationProvider>
  </div>
</template>
<script>
import {extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", required);

export default {
  name: "TextInput",
  props: {
    objeto: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    formRow: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    field_index: {
      type: Number,
      default: -1,
      required: false
    }
  },
  created() {
    if (
        this.formRow.attr.validations &&
        this.formRow.attr.validations.length > 0
    ) {
      this.rules = "required";
    }
  },
  computed: {
    value: {
      get() {
        return this.compute();
      },
      set: function (newValue) {
        this.$emit("on-update", {name: this.formRow.name, value: newValue});
        this.obj[this.formRow.name] = newValue;
      }
    }
  },
  data() {
    return {
      obj: this.objeto,
      rules: ""
    };
  },
  methods: {
    compute: function () {
      if (this.formRow.attr.computed) {
        //Preparo la operacion
        if (this.formRow["attr"]["funcion"]) {
          let operacion = this.formRow["attr"]["funcion"];
          this.formRow["attr"]["bindTo"].forEach(
              (bindField, index) => {
                operacion = operacion.replace(
                    new RegExp("@" + index, "g"),
                    "this.obj['" + bindField + "']"
                );
              }
          );
          let total = eval(operacion);
          if (!isNaN(total)) {
            this.obj[this.formRow["attr"]["resultField"]] = total;
          }
        }
      }
      return this.obj[this.formRow.name];
    }
  }
};
</script>
